import React from 'react'
import PropTypes from 'prop-types'
import { reduxForm } from 'redux-form'
import orderBy from 'lodash/orderBy'
import numeral from 'numeral'
import AuthenticatedFields from './fields/authenticated'
import UnauthenticatedFields from './fields/un-authenticated'
import validate from './validator'

const MessageSpaceOwnerForm = ({ isAuth, spaceOptions }) => {
  const spaceOptionsFormatted = spaceOptions.map(s => {
    let price = orderBy(s.prices, ['order'], ['desc'])
    const { amount = '', type = '' } = price[0] || {}
    price = `${numeral(amount).format('0,0.[00]')}/${type}`
    const label = `${s.title} - ${price}`

    return { value: s.id, label, preFormatted: { ...s } }
  })

  return isAuth ? (
    <AuthenticatedFields spaceOptions={spaceOptionsFormatted} />
  ) : (
    <UnauthenticatedFields spaceOptions={spaceOptionsFormatted} />
  )
}

MessageSpaceOwnerForm.propTypes = {
  isAuth: PropTypes.bool,
  spaceOptions: PropTypes.array,
}

export default reduxForm({ validate })(MessageSpaceOwnerForm)
